export enum ButtonType {
  primary,
  secondary,
  tertiary,
  link,
  primaryDark,
  secondaryDark,
  tertiaryDark,
  linkDark,
}
